<script src="./mvt-schoolmarker.js"></script>

<template>
  <CustomMarker :options="{ position, zIndex: currentZIndex }" class="pin-school" :class="{'pin-selected': isSelected}">
    <div class="mvt-schoolmarker" ref="markerRef">
      <div
          class="mvt-schoolmarker__marker"
          :class="{
            'mvt-schoolmarker__marker--selected': isSelected,
          }"
          @click="() => setSelected()"
          ref="buttonRef"
      >
        <div
            class="mvt-schoolmarker__dot"
        >
          <i class="icon-cap"></i>
        </div>
      </div>
      <div
          v-if="isSelected && !disablePopup"
          ref="cardRef"
          class="mvt-schoolmarker__card"
          :style="`--property-market-x: ${positionX}%; --property-market-y: ${positionY}%; visibility: ${isVisibility ? 'visible' : 'hidden'};`"
      >
        <mvtCardSchool :data="school" :onSwitchSchoolBoundary="() => setSelected(false)"/>
      </div>
    </div>
  </CustomMarker>
</template>

<style lang="scss">

.mvt-schoolmarker {

  position: relative;

  --map-marker-color-bg: var(--color-poi);
  --map-marker-color-border: var(--color-f);
  --map-marker-color: var(--color-f);
  --map-marker-color-bg-hover: var(--color-main);
  --map-marker-color-border-hover: var(--color-f);
  --map-marker-color-hover: var(--color-f);

  &__marker {
    z-index: 1;
    transform-origin: center center;
  }

  &__dot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    background-color: var(--map-marker-color-bg);
    border-radius: 50%;
    box-shadow: 0 0 0 2px var(--map-marker-color-border);
    color: var(--map-marker-color);
    transition: transform 0.1s ease-in;
    cursor: pointer;
    &:hover{
      transform: scale(1.5);
      background-color: var(--map-marker-color-bg-hover);
    }
  }

  &__card {
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(var(--property-market-x), var(--property-market-y));
    width: 22.5rem;

    &-image {
      height: 106px;
      width: 163px;
      background-color: gray;
    }

    &-text {
      display: flex;
      flex-direction: column;
    }

  }

}

</style>